import { render, staticRenderFns } from "./AlreadyBought.vue?vue&type=template&id=4398b4fd"
import script from "./AlreadyBought.vue?vue&type=script&lang=js"
export * from "./AlreadyBought.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports